module.exports = __webpack_public_path__ + "static/media/appointment.bcca69b3.svg";